// @module AwaLabs.ContactUs.ContactUsModule
define('ContactUsModule.View', [
    'contact_us_tmpl.tpl',
    'Backbone',
    'Backbone.FormView',
    'SC.Configuration',
    'underscore',
    'jQuery'
], function ContactUsModuleView(
    template,
    Backbone,
    BackboneFormView,
    Configuration,
    _,
    jQuery
) {
    ('use strict');

    var title = Configuration.get('ContactUsModule.title') || 'Contact Us';
    var route = Configuration.get('ContactUsModule.url') || 'contactus';
    var metaDescription = Configuration.get('ContactUsModule.metaDescription') || 'Contact Us';

    return Backbone.View.extend({
        template: template,
        // title: _(title).translate(),
        // page_header: _(title).translate(),
        // metaDescription: _(metaDescription).translate(),

        events: {
            'submit form': 'saveData'
        },

        bindings: {
            '[name="firstname"]': 'firstname',
            '[name="orderNumber"]': 'orderNumber',
            '[name="email"]': 'email',
            '[name="phone"]': 'phone',
            '[name="updateOrder"]': 'updateOrder',
            '[name="incomingmessage"]': 'incomingmessage'
        },

        attributes: {
            'class': 'contact-us'
        },

        getBreadcrumbPages: function getBreadcrumbPages() {
            return [
                {
                    text: _(this.title).translate(),
                    href: '/' + route
                }
            ];
        },

        initialize: function initialize(options) {
            var self = this;
            var currentPath = Backbone.history.fragment;
            var pageConfig = _.findWhere(Configuration.get('ContactUsModule.pages'), { url: currentPath });

            this.options = options;
            this.application = options.application;
            this.title = pageConfig.title;
            this.page_header = pageConfig.pageHeader;
            this.metaDescription = pageConfig.metaDescription;

            // sync configuration
            this.model.on('sync', jQuery.proxy(this, 'showSuccess'));

            // load the data needed by the form
            this.model.fetch().done(function success() {
                self.render();
            });

            BackboneFormView.add(this);
        },

        // Prevents not desired behaviour when hitting enter
        preventEnter: function preventEnter(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        },

        saveData: function saveData(e) {
            var self = this;
            var promise = BackboneFormView.saveForm.apply(this, arguments);

            e.preventDefault();
            return (promise && promise.then(
                function promiseSuccessCallback(data) {
                    if (data.successMessage) {
                        self.showMessage(data.successMessage, 'success');
                        self.$('form').get(0).reset();
                    } else {
                        self.showMessage('Error occurred, please try again.', 'error');
                    }
                },
                function promiseErrorCallback(jqXhr) {
                    jqXhr.preventDefault = true;
                    self.showMessage(jqXhr.responseJSON.errorMessage, 'error');
                })
            );
        },

        showMessage: function showMessage(message, type) {
            var $message = this.$('.message').removeClass('hide message-success message-error');

            if (type === 'success') {
                $message.addClass('message-success');
            } else {
                $message.addClass('message-error');
            }

            $message.text(message).fadeIn(400).delay(3000).fadeOut();
        },

        getContext: function getContext() {
            return {
                // @property {String} pageHeader
                pageHeader: this.page_header,
                // @property {Array} actionsOptions
                actionsOptions: this.model.get('status') === 200 ? this.model.get('data').orderActions : []
            };
        }
    });
});
